import request from '@/config/axios'

export const getMarketFestivalList = () => request.get({ url: '/market/festival/list' })
export const createMarketFestival = (data: Record<string, unknown>) =>
  request.post({ url: '/market/festival/create', data })
export const updateMarketFestival = (data: Record<string, unknown>) =>
  request.put({ url: '/market/festival/update', data })
export const deleteMarketFestival = (id: number) =>
  request.delete({ url: '/market/festival/delete', params: { id } })

export const getMarketIndustryList = () => request.get({ url: '/market/industry/list' })
export const createMarketIndustry = (data: Record<string, unknown>) =>
  request.post({ url: '/market/industry/create', data })
export const updateMarketIndustry = (data: Record<string, unknown>) =>
  request.put({ url: '/market/industry/update', data })
export const deleteMarketIndustry = (id: number) =>
  request.delete({ url: '/market/industry/delete', params: { id } })

export const getMarketSceneList = () => request.get({ url: '/market/scene/list' })
export const createMarketScene = (data: Record<string, unknown>) =>
  request.post({ url: '/market/scene/create', data })
export const updateMarketScene = (data: Record<string, unknown>) =>
  request.put({ url: '/market/scene/update', data })
export const deleteMarketScene = (id: number) =>
  request.delete({ url: '/market/scene/delete', params: { id } })

export const getMarketBoardTypeList = () => request.get({ url: '/market/board-type/list' })
export const getMarketBoardTypeEnabledList = () => request.get({ url: '/market/board-type/list-enabled' })
export const createMarketBoardType = (data: Record<string, unknown>) =>
  request.post({ url: '/market/board-type/create', data })
export const updateMarketBoardType = (data: Record<string, unknown>) =>
  request.put({ url: '/market/board-type/update', data })
export const deleteMarketBoardType = (id: number) =>
  request.delete({ url: '/market/board-type/delete', params: { id } })
